import { useEffect, useState } from "react";

import { setAnalyticsUserProperties } from "@/constants/amplitude";
import { CountryCodes, CurrencyCodes } from "@/constants/currency";
import { APPLE_PAY_MERCHANT_ID } from "@/constants/env";
import { useCurrency, useGeolocation } from "@/utils/GeolocationProvider";

import { useDeviceType } from "./useDeviceType";

export default function usePaymentSystem() {
    const { isMobile, isAndroid, isChrome } = useDeviceType();
    const { currency } = useCurrency();
    const { country } = useGeolocation();

    const isGooglePayAvailable = Boolean(isAndroid || (isChrome && !isMobile));
    const isVenmoEligible = country === CountryCodes.US && currency === CurrencyCodes.USD;

    const [isApplePayAvailable, setIsApplePayAvailable] = useState<boolean | null>(null);

    useEffect(() => {
        (async () => {
            if (window.ApplePaySession) {
                try {
                    const capabilities =
                        await window.ApplePaySession?.applePayCapabilities(APPLE_PAY_MERCHANT_ID);
                    const isApplePay =
                        capabilities?.paymentCredentialStatus === "paymentCredentialsAvailable";

                    setIsApplePayAvailable(isApplePay);
                    setAnalyticsUserProperties({ has_applepay: isApplePay });
                } catch (e) {
                    setIsApplePayAvailable(false);
                    setAnalyticsUserProperties({ has_applepay: false });
                }
            } else {
                setIsApplePayAvailable(false);
                setAnalyticsUserProperties({ has_applepay: false });
            }
        })();
    }, []);

    return {
        isApplePayAvailable,
        isGooglePayAvailable,
        isVenmoEligible,
    };
}
